import { CountryCode } from ':constants/countries';

export const YEXT_DISABLED_COUNTRY_CODES = [CountryCode.ITALY];

export const YEXT_SERVICES_MINIMUM_LIFETIME_BEFORE_DELETION_IN_DAYS = 31;
